import apiClient from 'utilities/apiClient';

export const actionforms = (url, payload) => {
  return apiClient.post(
    `${apiClient.Urls.feedbackData}/${url}`,
    payload,
    true,
    'file'
  );
};
